import styled from "@emotion/styled";
import { default as TrophyIcon } from "/public/assets/trophy.svg?react";

export const RaffleTrophy = styled(TrophyIcon)<{ size?: number }>`
  width: ${(props) => props.size ?? 24}px;
  height: ${(props) => props.size ?? 24}px;
`;
